<div class="login-card">
    <div>
        <div class="login-main">
            <div class="theme-form needs-validation">
                <h4 style=" font-size: 22px;margin-bottom:20px">Connecting to your LinkedIn profile</h4>
                <div>
                    <div *ngIf="show_invalid_message" class="form-group">
                        <p>There is an error while connecting to your LinkedIn profile.</p>
                        <p>Please  <a [routerLink]="'/auth/login-email'">click here</a> and choose another way to login to mygistec portal</p>
                    </div>
                    <div *ngIf="show_loading">
                        <div class="spinner-grow text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>